import PinInput from './PinInput';

export default PinInput;



// WEBPACK FOOTER //
// ./src/index.js